import React, { useState } from "react";
import styles from "../../assets/styles/loan.module.css";
import Strings from "../../utils/stringUtil";
import { loanFaqsList } from "../../utils/businessLoanUtil";
import { Box, Button, Collapse, Typography } from "@mui/material";
import AppIcons from "../../utils/appIcons";
import { isMobile } from "../../utils/responsiveUtil";
import Routes from "../../utils/routesUtil";
import { Link } from "react-router-dom";

function BusinessLoanFaqs() {
  const minFaqsCount = 5;

  /* showing first 5 faqs for default */
  const [accordionIndex, setAccordionIndex] = useState(-1);
  const [currentFaqs, setCurrentFaqs] = useState(
    loanFaqsList.slice(0, minFaqsCount)
  );

  function handleOnClickQuestion(index) {
    setAccordionIndex(index === accordionIndex ? -1 : index);
  }

  return (
    <Box pt={"57px"} pb={"70px"} className={"container"}>
      <Box
        position={"relative"}
        style={{ transform: isMobile ? "scale(1)" : "scale(0.94)" }}
      >
        <Typography className={styles.loanTitle}>{Strings.faqTitle}</Typography>

        <Box mt={isMobile ? "30px" : "48px"}>
          {currentFaqs.map((faq, index) => {
            const isAccordionSelected = index === accordionIndex;
            return (
              <Box key={index}>
                {/* question section */}
                <Box
                  className={`${styles.cursorPointer} ${styles.accordionQues}`}
                  mt={"16px"}
                  onClick={() => handleOnClickQuestion(index)}
                >
                  <Typography className={styles.accordionQuesText}>
                    {faq.question}
                  </Typography>

                  {/* expanded and collapsed icon */}
                  <Box>
                    {isAccordionSelected ? (
                      <img src={AppIcons.icArrowUp} />
                    ) : (
                      <img src={AppIcons.icArrowDown} />
                    )}
                  </Box>
                </Box>

                {/* answer section */}
                <Collapse in={isAccordionSelected}>
                  <Box className={styles.accordionAns} mt={"8px"}>
                    <Typography
                      className={styles.accordionAnsText}
                      dangerouslySetInnerHTML={{
                        __html: faq.answer,
                      }}
                    ></Typography>
                  </Box>
                </Collapse>
              </Box>
            );
          })}
        </Box>

        {/*  read more faqs button to show faqs more than 5  */}
        <Box className={styles.readMoreBtnWrapper}>
          <Link
            className={styles.readMoreBtn}
            to={Routes.FREQUENTLY_ASKED_QUESTIONS}
          >
            {Strings.readMoreFaqs}
          </Link>
        </Box>
      </Box>
    </Box>
  );
}

export default BusinessLoanFaqs;
